"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInputDate = void 0;
const timeZones_1 = require("../../constants/timeZones");
const luxon_1 = require("luxon");
function parseInputDate(date) {
    if (!date)
        return null;
    if (typeof date === 'number') {
        return luxon_1.DateTime.fromMillis(date, { zone: timeZones_1.TIME_ZONE.EASTERN });
    }
    else if (typeof date === 'object') {
        return luxon_1.DateTime.fromJSDate(date, { zone: timeZones_1.TIME_ZONE.EASTERN });
    }
    else {
        const isoDate = luxon_1.DateTime.fromFormat(date, 'yyyy-MM-dd', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (isoDate.isValid) {
            return isoDate;
        }
        let customDate = luxon_1.DateTime.fromFormat(date, 'MM/dd/yyyy', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'MM-dd-yyyy', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'yyyy/MM/dd', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'yyyyMMdd', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'yyyy.MM.dd', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'MM.dd.yyyy', { zone: timeZones_1.TIME_ZONE.EASTERN }).startOf('day');
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss', {
            zone: timeZones_1.TIME_ZONE.EASTERN,
        });
        if (customDate.isValid) {
            return customDate;
        }
        customDate = luxon_1.DateTime.fromFormat(date, 'yyyy-MM-dd HH:mm:ss.SSS', {
            zone: timeZones_1.TIME_ZONE.EASTERN,
        });
        if (customDate.isValid) {
            return customDate;
        }
        if (date.indexOf('T') !== -1) {
            customDate = luxon_1.DateTime.fromISO(date, { zone: timeZones_1.TIME_ZONE.EASTERN });
            if (customDate.isValid) {
                return customDate;
            }
        }
        return null;
    }
}
exports.parseInputDate = parseInputDate;
//# sourceMappingURL=index.js.map